import Radio from 'components/Form/RadioButtonType'
import React, {
  Fragment,
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react'

//importing components
import { Checkbox } from 'antd'
import Control from 'components/Control/Control'
import Divider from 'components/Divider/Divider'
import AntdInput from 'components/Form/Input'
import AntdSelect from 'components/Form/Select'
import AntdSelectNew from 'components/Form/SelectNew'
import Label from 'components/Label/Label'
import RichEditor from 'components/RichEditor/index'
import FileReaderVisible from 'components/Uploader/FileReaderVisible'
import Uploadloader from 'components/Uploader/Uploader'
import AddIcon from 'components/icons/AddIcon'
import Delete from 'components/icons/Delete'
import Dropdown from 'components/icons/Dropdown'
import { MonthList } from 'modules/Onboarding/Register/Education/constant'
import {
  RadioGroupNew,
  AdjustIcon,
} from 'modules/Resume/DrawerComponents/DrawerStyle'
import { searchConfig } from 'utils/config'
import {
  Container,
  FormItem,
  Heading,
  IconView,
  SubHeading,
} from 'modules/Resume/DrawerComponents/EducationDetailStyle'
import WorkExpAwardForm from 'modules/Resume/DrawerComponents/ProjectDetails/WorkExpAwardForm'
import { Text } from 'modules/Resume/DrawerComponents/ProjectDetails/style'
import moment from 'moment'

import {
  getValuebyName,
  mumericToBooleanConverter,
} from '../../../../utils/helpers'
import { LocalDiv, StyledFormItem } from '../Education/style'
import { RedNote } from '../PersonalInfo/style'

const ProjectForm = ({
  form,
  formName,
  onRemove,
  studentFormData,
  isPresent,
  setIsPresent,
  setCorporateName,
  corporateName,
  setCorporateId,
  corporateId,
  getListOfSkills,
  setSkillLoading,
  skillLoading,
  getCorporateList,
  SkillsAPI,
  allSkills,
  getDesignationsList,
  getFunctionsList,
  getIndustryList,
  isCvTrue,
  searchAPI,
  isExpUpdated,
  frozenFields = {},
}) => {
  let errorCompany = `${formName}Company`
  let errorRole = `${formName}Role`
  let errorFunction = `${formName}Funtion`
  let errorIndustry = `${formName}Industry`
  const [errorNote, setErrorNote] = useState()
  const [show, setShow] = useState(true)
  const [projectTitle, setProjectTitle] = useState(
    form.getFieldValue([[formName], 'title'])
  )

  const [listOfSkills, setListOfSkills] = useState(allSkills ?? [])
  const [storeSkill, setStoreSkill] = useState([])
  const [functionsList, setFunctionsList] = useState([])
  const [roleList, setRoleList] = useState([])
  const [industryList, setIndustryList] = useState([])
  const [skillFetch, setSkillFetch] = useState(true)
  const [timeLine, setTimeLine] = useState('')
  const [startDate, setStartDate] = useState('')
  const [startMonth, setStartMonth] = useState('')
  const [startYear, setStartYear] = useState('')
  const [endDate, setEndDate] = useState('')
  const [endMonth, setEndMonth] = useState('')
  const [endYear, setEndYear] = useState('')
  const [noticePeriod, setNoticePeriod] = useState()
  const [description, setDescription] = useState('')
  const [selectedSkill, setSelectedSkill] = useState([])
  const [skillErrorMsg, setSkillErrorMsg] = useState('')
  const [award, setAward] = useState([])
  const [awardList, setAwardList] = useState([])

  const [companyList, setCompanyList] = useState([])
  const [file, setFile] = useState(
    form.getFieldValue([[formName], 'certificate'])
  )
  const [isJobType, setIsJobType] = useState(
    form.getFieldValue([[formName], 'jobType'])
  )
  const [isCurrentlyWorking, setIsCurrentlyWorking] = useState(
    mumericToBooleanConverter(
      form.getFieldValue([[formName], 'isCurrentlyWorking'])
    )
  )
  const [dateErrorMsg, setDateErrorMsg] = useState('')
  const [workErrorMsg, setWorkErrorMsg] = useState('')
  const [roleSearch, setRoleSearch] = useState('')
  const [functionSearch, setFunctionSearch] = useState('')
  const [options, setOptions] = useState([])
  const [compSearch, setCompSearch] = useState('')

  const currentYear = moment().year()
  const [deleted, setDeleted] = useState(false)

  const years = []
  for (let year = currentYear; year >= 1923; year--) {
    years.push({
      value: year,
      name: year,
    })
  }
  useEffect(() => {
    if (roleList) {
      setOptions(roleList)
    }
  }, [roleList])

  useEffect(() => {
    if (roleSearch) {
      const lowercaseRoleSearch = roleSearch?.toLowerCase()
      if (roleSearch?.length > 0) {
        if (
          !options?.some(option => {
            const lowercaseOptionName = option?.name?.toLowerCase()
            return lowercaseOptionName === lowercaseRoleSearch
          })
        ) {
          setOptions(prev => [{ name: roleSearch, id: '' }, ...prev])
        }
      }
      form.setFieldsValue({ [formName]: { role: '' } })
    }
  }, [roleSearch, options, roleList])
  useEffect(() => {
    if (functionsList.length === 0) {
      setFunctionsList([
        {
          name: 'Other',
          id: 'OTHER',
          isActive: 'true',
        },
        ...functionsList,
      ])
    }
  }, [functionsList])
  useEffect(() => {
    if (industryList.length === 0) {
      setIndustryList([
        {
          name: 'Other',
          id: 'OTHER',
          isActive: 'true',
        },
        ...industryList,
      ])
    }
  }, [industryList])

  const RadioOptions = [
    {
      id: 1,
      label: 'Full-time',
      value: 'FULL_TIME',
    },
    {
      id: 2,
      label: 'Part-time',
      value: 'PART_TIME',
    },
  ]

  useLayoutEffect(() => {
    updateCorporateData()
    updateDesignationData()
    updateFunctionData()
    updateIndustryData()
  }, [])

  useEffect(() => {
    form.setFieldValue([[formName], 'shown'], true)
    setAwardList(form.getFieldValue([[formName], 'awards']))
  }, [])

  useEffect(() => {
    let listData = []
    if (awardList !== undefined) {
      awardList.forEach((data, index) => {
        let formName1 = formName + '_award_' + index
        const formattedDescription = Array.isArray(data?.description)
          ? data.description.map(item => `${item}`).join('\n')
          : data?.description
        form.setFieldsValue({
          [formName1]: {
            title: data?.title,
            awarded_on: data?.awarded_on,
            description: formattedDescription,
            certificate: data?.certificate,
          },
        })
        listData.push({
          component: WorkExpAwardForm,
          formName: formName1,
        })
      })

      setAward(listData)
    }
  }, [awardList])
  useEffect(() => {
    let updatedList = []
    let formDatas = form.getFieldValue()
    Object.entries(formDatas).forEach(([name, item]) => {
      if (name.includes('award') && name.includes(formName)) {
        form.setFieldValue({
          [name]: {
            ...item,
          },
        })
        updatedList.push({
          component: WorkExpAwardForm,
          formName: name,
        })
      }
    })

    setAward(updatedList)
  }, [isExpUpdated])

  useLayoutEffect(() => {
    const startedIn = form.getFieldValue([[formName], 'started_in'])

    if (
      startedIn &&
      startedIn != undefined &&
      moment(startedIn, 'MM/YYYY', true).isValid()
    ) {
      const dateParts = startedIn.split('/')
      setStartMonth(dateParts[0])
      setStartYear(dateParts[1])
      form.setFieldsValue({ [formName]: { startMonth: dateParts[0] } })
      form.setFieldsValue({ [formName]: { startYear: dateParts[1] } })
      setStartDate(moment(form.getFieldValue([[formName], 'started_in'])))
    }

    const endedIn = form.getFieldValue([[formName], 'ended_in'])

    if (
      endedIn &&
      endedIn != undefined &&
      moment(endedIn, 'MM/YYYY', true).isValid()
    ) {
      const dateParts = endedIn.split('/')
      setEndMonth(dateParts[0])
      setEndYear(dateParts[1])
      form.setFieldsValue({ [formName]: { endMonth: dateParts[0] } })
      form.setFieldsValue({ [formName]: { endYear: dateParts[1] } })
      setEndDate(moment(form.getFieldValue([[formName], 'ended_in'])))
    }
    if (form.getFieldValue([[formName], 'noticePeriod']) != undefined) {
      setNoticePeriod(form.getFieldValue([[formName], 'noticePeriod']))
    }
    setIsCurrentlyWorking(
      mumericToBooleanConverter(
        form.getFieldValue([[formName], 'isCurrentlyWorking'])
      )
    )

    updateSkillsData()
  }, [form.getFieldValue([[formName], 'started_in'])])

  const onBlurProjectTitle = e => {
    if (e.target.value.trim()) {
      form.setFieldsValue({ [formName]: { title: e.target.value?.trim() } })
      setProjectTitle(e.target.value?.trim())
    } else {
      form.setFieldsValue({ [formName]: { title: '' } })
      setProjectTitle('')
    }
  }

  const validator = (rule, value) => {
    const startDate = moment(
      `${form.getFieldValue([[formName], 'startYear'])}-${form.getFieldValue([
        [formName],
        'startMonth',
      ])}-01`
    )
    const endDate = moment(
      `${form.getFieldValue([[formName], 'endYear'])}-${form.getFieldValue([
        [formName],
        'endMonth',
      ])}-01`
    )

    const isStartMonthInList =
      MonthList.find(
        item => item.value == form.getFieldValue([[formName], 'startMonth'])
      ) !== undefined
    const isStartYearInList =
      years.find(
        item => item.value == form.getFieldValue([[formName], 'startYear'])
      ) !== undefined
    const isEndMonthInList =
      MonthList.find(
        item => item.value == form.getFieldValue([[formName], 'endMonth'])
      ) !== undefined
    const isEndYearInList =
      years.find(
        item => item.value == form.getFieldValue([[formName], 'endYear'])
      ) !== undefined

    const now = moment()

    if (
      form.getFieldValue([[formName], 'startMonth']) === undefined ||
      !isStartMonthInList
    ) {
      // setDateErrorMsg(' Please select StartMonth')
      form.setFieldsValue({ [formName]: { error: 'Please select StartMonth' } })
      return Promise.reject(new Error(''))
    } else if (
      form.getFieldValue([[formName], 'startYear']) === undefined ||
      !isStartYearInList
    ) {
      // setDateErrorMsg(' Please select StartYear')
      form.setFieldsValue({ [formName]: { error: 'Please select StartYear' } })
      return Promise.reject(new Error(''))
    } else if (startDate > now) {
      setDateErrorMsg(' Start Date cannot be in the future')
      form.setFieldsValue({
        [formName]: { error: 'Start Date cannot be in the future' },
      })
      return Promise.reject(new Error(''))
    } else if (
      form.getFieldValue([[formName], 'endMonth']) === undefined ||
      !isEndMonthInList
    ) {
      // setDateErrorMsg(' Please select EndMonth')
      form.setFieldsValue({ [formName]: { error: 'Please select EndMonth' } })
      return Promise.reject(new Error(''))
    } else if (
      form.getFieldValue([[formName], 'endYear']) === undefined ||
      !isEndYearInList
    ) {
      // setDateErrorMsg(' Please select EndYear')
      form.setFieldsValue({ [formName]: { error: 'Please select EndYear' } })
      return Promise.reject(new Error(''))
    } else if (endDate > now) {
      setDateErrorMsg(' End Date cannot be in the future')
      form.setFieldsValue({
        [formName]: { error: 'End Date cannot be in the future' },
      })
      return Promise.reject(new Error(''))
    } else if (endDate < startDate) {
      setDateErrorMsg('End date cannot be before start date')
      form.setFieldsValue({
        [formName]: { error: 'End date cannot be before start date' },
      })
      return Promise.reject(new Error(''))
    } else {
      setDateErrorMsg('')
      return Promise.resolve()
    }
  }

  const workValidator = (rule, value) => {
    const startDate = moment(
      `${form.getFieldValue([[formName], 'startYear'])}-${form.getFieldValue([
        [formName],
        'startMonth',
      ])}-01`
    )
    const endDate = moment(
      `${form.getFieldValue([[formName], 'endYear'])}-${form.getFieldValue([
        [formName],
        'endMonth',
      ])}-01`
    )
    const now = moment()

    const isStartMonthInList =
      MonthList.find(
        item => item.value == form.getFieldValue([[formName], 'startMonth'])
      ) !== undefined
    const isStartYearInList =
      years.find(
        item => item.value == form.getFieldValue([[formName], 'startYear'])
      ) !== undefined
    const isEndMonthInList =
      MonthList.find(
        item => item.value == form.getFieldValue([[formName], 'endMonth'])
      ) !== undefined
    const isEndYearInList =
      years.find(
        item => item.value == form.getFieldValue([[formName], 'endYear'])
      ) !== undefined

    if (
      form.getFieldValue([[formName], 'startMonth']) === undefined ||
      !isStartMonthInList
    ) {
      // setWorkErrorMsg(' Please select StartMonth')
      form.setFieldsValue({ [formName]: { error: 'Please select StartMonth' } })
      return Promise.reject(new Error(''))
    } else if (
      form.getFieldValue([[formName], 'startYear']) === undefined ||
      !isStartYearInList
    ) {
      // setWorkErrorMsg(' Please select StartYear')
      form.setFieldsValue({ [formName]: { error: 'Please select StartYear' } })
      return Promise.reject(new Error(''))
    } else if (startDate > now) {
      setWorkErrorMsg(' Start Date cannot be in the future')
      form.setFieldsValue({
        [formName]: { error: 'Start Date cannot be in the future' },
      })
      return Promise.reject(new Error(''))
    } else if (
      (!isCurrentlyWorking &&
        form.getFieldValue([[formName], 'endMonth']) === undefined) ||
      (!isCurrentlyWorking && !isEndMonthInList)
    ) {
      // setWorkErrorMsg(' Please select EndMonth')
      form.setFieldsValue({ [formName]: { error: 'Please select EndMonth' } })
      return Promise.reject(new Error(''))
    } else if (
      (!isCurrentlyWorking &&
        form.getFieldValue([[formName], 'endYear']) === undefined) ||
      (!isCurrentlyWorking && !isEndYearInList)
    ) {
      // setWorkErrorMsg(' Please select EndYear')
      form.setFieldsValue({ [formName]: { error: 'Please select EndYear' } })
      return Promise.reject(new Error(''))
    } else if (
      !isCurrentlyWorking &&
      form.getFieldValue([[formName], 'endYear']) != undefined &&
      form.getFieldValue([[formName], 'endMonth']) != undefined &&
      endDate > now
    ) {
      setWorkErrorMsg(' End Date cannot be in the future')
      form.setFieldsValue({
        [formName]: { error: 'End Date cannot be in the future' },
      })
      return Promise.reject(new Error(''))
    } else if (
      !isCurrentlyWorking &&
      form.getFieldValue([[formName], 'endYear']) != undefined &&
      form.getFieldValue([[formName], 'endMonth']) != undefined &&
      endDate < startDate
    ) {
      setWorkErrorMsg('End date cannot be before start date')
      form.setFieldsValue({
        [formName]: { error: 'End date cannot be before start date' },
      })
      return Promise.reject(new Error(''))
    } else {
      setWorkErrorMsg('')
      return Promise.resolve()
    }
  }

  const onStartMonthChange = data => {
    setStartMonth(data)
    form.setFieldsValue({ [formName]: { startMonth: data } })
  }
  const onStartYearChange = data => {
    setStartYear(data)
    form.setFieldsValue({ [formName]: { startYear: data } })
  }

  const onEndMonthChange = data => {
    setEndMonth(data)
    form.setFieldsValue({ [formName]: { endMonth: data } })
  }
  const onEndYearChange = data => {
    setEndYear(data)
    form.setFieldsValue({ [formName]: { endYear: data } })
  }

  const onNoticePeriodChange = data => {
    setNoticePeriod(data)
    form.setFieldsValue({ [formName]: { noticePeriod: data } })
  }

  const onFunctionChange = (data, option) => {
    if (data?.toUpperCase() === 'OTHER') {
      form.setFieldsValue({ [formName]: { addFunction: 'OTHER' } })
      form.setFieldsValue({ [formName]: { function: '' } })
    } else {
      form.setFieldsValue({
        [formName]: { addFunction: null },
      })
      form.setFieldsValue({ [formName]: { function: option?.option?.name } })
    }
    setErrorNote(prevErrorNote => ({
      ...prevErrorNote,
      [errorFunction]: '',
    }))
    if (!data) {
      functionSearching()
    }
  }

  const onRoleChange = data => {
    setErrorNote(prevErrorNote => ({
      ...prevErrorNote,
      [errorRole]: '',
    }))
    form.setFieldsValue({ [formName]: { role: data } })
    setRoleSearch('')
  }

  const onIndustryChange = (data, option) => {
    if (data?.toUpperCase() === 'OTHER') {
      form.setFieldsValue({ [formName]: { addIndustry: 'OTHER' } })
      form.setFieldsValue({ [formName]: { industry: '' } })
    } else {
      form.setFieldsValue({
        [formName]: { addIndustry: null },
      })
      form.setFieldsValue({ [formName]: { industry: option?.option?.name } })
    }
    setErrorNote(prevErrorNote => ({
      ...prevErrorNote,
      [errorIndustry]: '',
    }))
    if (!data) {
      industrySearching()
    }
  }
  const onSkillChange = (value, id) => {
    let list = []
    let skillList = []

    for (const item of id) {
      list.push(item?.id)
      let obj = {
        name: item?.name,
        id: item?.id,
      }
      skillList.push(obj)
    }
    setSelectedSkill(list)
    setStoreSkill(skillList)
    form.setFieldsValue({ [formName]: { skill_set: skillList } })
    delaySkillToFetch('')
    if (skillList.length > 20) {
      setSkillErrorMsg('Maximum 20 Skills only allowed')
    } else {
      // Clear the error message if skillList is within the limit
      setSkillErrorMsg('')
    }
  }

  const onChangeDescription = data => {
    form.setFieldsValue({ [formName]: { description: data } })
    setDescription(data)
  }

  const NoticePeriodList = []
  for (let year = 1; year <= 100; year++) {
    NoticePeriodList.push({
      value: year,
      name: year,
    })
  }

  const getFormName = level => {
    let name = level.replaceAll('_', '')
    return name?.replace(/\d/g, '')
  }
  const showHandler = () => {
    show ? setShow(false) : setShow(true)
    form.setFieldValue([[formName], 'shown'], show ? false : true)
  }

  const getTitle = formName => {
    if (formName?.includes('project')) {
      return 'Project'
    } else if (formName?.includes('internship')) {
      return 'Internship'
    } else if (formName?.includes('experience')) {
      return 'Experience'
    } else if (formName?.includes('course')) {
      return 'Course'
    }
  }

  const updateSkillsData = () => {
    let sillsList = form?.getFieldValue([[formName], 'skill_set']) || []
    let newSkillSet = []
    if (sillsList?.length && listOfSkills?.length && Array.isArray(sillsList)) {
      for (let skill of sillsList) {
        if (skill?.name && !skill?.id) {
          let skillObj = getValuebyName(listOfSkills, skill?.name)
          if (skillObj) {
            skill.id = skillObj.id

            newSkillSet.push({ id: skillObj?.id, name: skillObj?.name })
          }
        } else {
          newSkillSet.push(skill)
        }
      }
      form.setFieldsValue({
        [formName]: { skill_set: newSkillSet?.length ? newSkillSet : [] },
      })
      setSelectedSkill(
        newSkillSet ? newSkillSet?.map(({ id }) => id) || [] : []
      )
      setStoreSkill(newSkillSet || [])
    } else if (storeSkill?.length) {
      form.setFieldsValue({ [formName]: { skill_set: storeSkill } })
    }
    setTimeout(() => {
      setSkillFetch(false)
    }, 200)
  }

  useEffect(() => {
    updateSkillsData()
  }, [listOfSkills])

  const skillSearching = async (skillName = '') => {
    try {
      const result = await SkillsAPI(skillName);

      setListOfSkills(!skillName ? allSkills : result)
    } catch (err) {
      console.log(err)
    }
  }

  const delaySkillToFetch = useCallback(
    debounce(data => {
      skillSearching(data)
    }, 500),
    []
  )

  useEffect(() => {
    form.setFieldsValue({ [formName]: { certificate: file } })
  }, [file])
  useEffect(() => {
    if ((startDate && endDate) || isCurrentlyWorking) {
      setTimeLine(
        `${
          moment(
            form.getFieldValue([[formName], 'started_in']),
            'MM/YYYY'
          ).format('MMMM YYYY') +
          (isCurrentlyWorking
            ? '- Present'
            : endMonth
            ? '-' +
              moment(
                form.getFieldValue([[formName], 'ended_in']),
                'MM/YYYY'
              ).format('MMMM YYYY')
            : '')
        }`
      )
    }
  }, [startDate, endDate, isCurrentlyWorking])

  const awardHandle = (isAdd, isDelete, deleteForm) => {
    let awardLength = award?.length

    let arr = []
    let formName1 = formName + '_award_' + awardLength
    if (isAdd) {
      form.setFieldsValue({ [formName1]: null })
      arr.push({ component: WorkExpAwardForm, formName: formName1 })

      setAward(exp => exp.concat(arr))
    }
    if (isDelete) {
      form.setFieldsValue({
        [deleteForm]: null,
      })
      let updatedList = []
      award
        ?.filter(data => data?.formName !== deleteForm)
        .forEach((item, index) => {
          let formName1 = formName + '_award_' + index
          let currentFormValue = form.getFieldValue([item.formName])
          form.setFieldsValue({
            [item.formName]: null,
          })
          form.setFieldsValue({
            [formName1]: {
              ...currentFormValue,
            },
          })
          updatedList.push({
            component: WorkExpAwardForm,
            formName: formName1,
          })
        })

      setAward(updatedList)
    }
  }

  const functionSearching = async (functionName = '') => {
    try {
      if (functionName) {
        setErrorNote(prevErrorNote => ({
          ...prevErrorNote,
          [errorFunction]: '',
        }))
      }
      const res = await searchAPI(
        searchConfig?.function?.name,
        functionName,
        searchConfig?.function
      )
      let list = res || []
      setFunctionsList(list)
      return list
    } catch (err) {
      console.log(err)
    }
  }
  const designationSearching = async (designationName = '') => {
    try {
      if (designationName) {
        setErrorNote(prevErrorNote => ({
          ...prevErrorNote,
          [errorRole]: '',
        }))
      }
      const res = await getDesignationsList(designationName)
      let list = res?.data?.data?.list || []
      setRoleList(list)
      return list
    } catch (err) {
      console.log(err)
    }
  }
  const industrySearching = async (industryName = '') => {
    try {
      if (industryName) {
        setErrorNote(prevErrorNote => ({
          ...prevErrorNote,
          [errorIndustry]: '',
        }))
      }
      const res = await searchAPI(
        searchConfig?.industries?.name,
        industryName,
        searchConfig?.industries
      )
      let list = res || []
      setIndustryList(list)
      return list
    } catch (err) {
      console.log(err)
    }
  }

  const delayFunctionToFetch = useCallback(
    debounce(async data => {
      form.setFieldValue([[formName], 'function'], '')
      await functionSearching(data)
    }, 500),
    []
  )

  const delayCompanyToFetch = useCallback(
    debounce(async data => {
      form.setFieldValue([[formName], 'company'], '')
      await companySearching(data)
    }, 500),
    []
  )

  function debounce(fn, delay) {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }

  useEffect(() => {
    let getData
    getData = setTimeout(async () => {
      await designationSearching(roleSearch)
    }, 500)
    return () => clearTimeout(getData)
  }, [roleSearch])

  const delayIndustryToFetch = useCallback(
    debounce(async data => {
      form.setFieldValue([[formName], 'industry'], '')

      await industrySearching(data)
    }, 500),
    []
  )

  useEffect(() => {
    if (startMonth && startYear) {
      let date = startMonth + '/' + startYear
      form.setFieldsValue({ [formName]: { started_in: date } })
      setStartDate(date)
    }
  }, [startMonth, startYear])

  useEffect(() => {
    if (endMonth && endYear) {
      let date = endMonth + '/' + endYear
      form.setFieldsValue({ [formName]: { ended_in: date } })
      setEndDate(date)
    }
  }, [endMonth, endYear])

  const validateSkill = (rule, value, callback) => {
    if (form?.getFieldValue([[formName], 'skill_set'])?.length > 20) {
      setSkillErrorMsg('')
      return Promise.reject(new Error('Maximum 20 Skills only allowed'))
    } else {
      return Promise.resolve()
    }
  }

  const countRichTextCharacters = richText => {
    if (!richText) return 0
    
    const textString = typeof richText === 'string' ? richText : String(richText)
    
    // Remove HTML tags using a regular expression
    const plainText = textString.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ')

    // Count the characters in the plain text
    const characterCount = plainText.length || 0

    return characterCount
  }

  const isCurrentlyOnChange = data => {
    const startDate = moment(
      `${form.getFieldValue([[formName], 'startYear'])}-${form.getFieldValue([
        [formName],
        'startMonth',
      ])}-01`
    )
    const endDate = moment(
      `${form.getFieldValue([[formName], 'endYear'])}-${form.getFieldValue([
        [formName],
        'endMonth',
      ])}-01`
    )

    const now = moment()
    setIsCurrentlyWorking(data?.target?.checked)
    form.setFieldsValue({
      [formName]: {
        isCurrentlyWorking: data?.target?.checked,
      },
    })
    setIsPresent(data?.target?.checked)
    if (data?.target?.checked) {
      setEndYear('')
      setEndMonth('')
      setEndDate('')
      form.setFieldsValue({ [formName]: { endYear: '' } })
      form.setFieldsValue({ [formName]: { ended_in: '' } })
      form.setFieldsValue({ [formName]: { endMonth: '' } })
      if (
        form.getFieldValue([[formName], 'endYear']) === null ||
        form.getFieldValue([[formName], 'endMonth']) === null ||
        form.setFieldsValue({ [formName]: { ended_in: '' } }) ||
        endDate > now ||
        endDate < startDate
      ) {
        setWorkErrorMsg('')
        form.setFieldsValue({
          [formName]: { error: '' },
        })
      }
    } else if (!data?.target?.checked) {
      if (
        form.getFieldValue([[formName], 'endYear']) === '' ||
        form.getFieldValue([[formName], 'endYear']) === undefined
      ) {
        setWorkErrorMsg(' Please select EndYear')
        form.setFieldsValue({ [formName]: { error: 'Please select EndYear' } })
      }
      if (
        form.getFieldValue([[formName], 'endMonth']) === '' ||
        form.getFieldValue([[formName], 'endMonth']) === undefined
      ) {
        setWorkErrorMsg(' Please select EndMonth')
        form.setFieldsValue({
          [formName]: { error: 'Please select EndMonth' },
        })
      }
      if (
        form.getFieldValue([[formName], 'endYear']) != '' &&
        form.getFieldValue([[formName], 'endYear']) != undefined &&
        form.getFieldValue([[formName], 'endMonth']) != '' &&
        form.getFieldValue([[formName], 'endMonth']) != undefined &&
        endDate > now
      ) {
        setWorkErrorMsg(' End Date cannot be in the future')
        form.setFieldsValue({
          [formName]: { error: 'End Date cannot be in the future' },
        })
      }
      if (
        form.getFieldValue([[formName], 'endYear']) != '' &&
        form.getFieldValue([[formName], 'endYear']) != undefined &&
        form.getFieldValue([[formName], 'endMonth']) != '' &&
        form.getFieldValue([[formName], 'endMonth']) != undefined &&
        endDate < startDate
      ) {
        setWorkErrorMsg('End date cannot be before start date')
        form.setFieldsValue({
          [formName]: { error: 'End date cannot be before start date' },
        })
      }
    }
  }

  const jobTypeOnchange = data => {
    if (data === false) {
      form.setFieldsValue({ [formName]: { jobType: '' } })
    }
    setIsJobType(data)
    form.setFieldsValue({ [formName]: { jobType: data } })
  }

  const companySearching = async (companyName = '') => {
    try {
      if (companyName) {
        setErrorNote(prevErrorNote => ({
          ...prevErrorNote,
          [errorCompany]: '',
        }))
      }
      const res = await searchAPI(
        searchConfig?.companyMaster?.name,
        companyName,
        searchConfig?.companyMaster
      )
      let list = res || [];
      let data = [
        {
          companyName: companyName,
          id: '',
          shortName: '',
        }
      ];
      
      if (list.length === 0) {
        setCompanyList(data);
      } else {
        setCompanyList([data, ...list]);
      }
      
      return list
    } catch (err) {
      console.log(err)
    }
  }

  const onCorporateChange = (data, option) => {
    if (option?.option?.companyName?.trimStart()) {
      setCorporateName(option?.option?.companyName)
      setCorporateId(option?.option?.id)
      form.setFieldsValue({
        [formName]: { organization: option?.option?.companyName },
      })
      form.setFieldsValue({ [formName]: { corporateId: option?.option?.id } })
      setErrorNote(prevErrorNote => ({
        ...prevErrorNote,
        [errorCompany]: '',
      }))
    } else {
      form.setFieldsValue({
        [formName]: { organization: '' },
      })
      form.setFieldsValue({
        [formName]: { corporateId: '' },
      })

      setCorporateName('')
      setCorporateId('')
    }
    setCompSearch('')
    delayCompanyToFetch('')
  }

  const onCorporateBlur = () => {
    if (!compSearch == '') {
      form.setFieldsValue({
        [formName]: { organization: '' },
      })
      form.setFieldsValue({
        [formName]: { corporateId: '' },
      })
      setCorporateName('')
      setCorporateId('')
      setCompSearch('')
    }
  }

  const onBlurHandler = key => {
    if (!form.getFieldValue([[formName], [key]])?.trim()) {
      form.setFieldsValue({ [formName]: { [key]: '' } })
    } else {
      form.setFieldsValue({
        [formName]: { [key]: form.getFieldValue([[formName], [key]])?.trim() },
      })
    }
  }
  // useEffect(() => {
  //   let getData
  //   getData = setTimeout(async () => {
  //     const res = await searchAPI(
  //       searchConfig?.companyMaster?.name,
  //       compSearch,
  //       searchConfig?.companyMaster
  //     )
  //     let list = res || []
  //     setCompanyList(list)
  //   }, 500)
  //   return () => clearTimeout(getData)
  // }, [compSearch])

  useEffect(() => {
    if (compSearch) {
      const lowercaseCompSearch = compSearch?.toLowerCase()
      if (compSearch?.length > 0) {
        if (
          !companyList?.some(option => {
            const lowercaseOptionName = option?.companyName?.toLowerCase()
            return lowercaseOptionName === lowercaseCompSearch
          })
        ) {
          setCompanyList(prev => [{ companyName: compSearch, id: '' }, ...prev])
        }
      }
    }
  }, [compSearch, companyList])
  // useEffect(() => {
  //   let getData
  //   getData = setTimeout(async () => {
  //     const res = await searchAPI(
  //       searchConfig?.companyMaster?.name,
  //       compSearch,
  //       searchConfig?.companyMaster
  //     )
  //     let list = res || []
  //     setCompanyList(list)
  //   }, 500)
  //   return () => clearTimeout(getData)
  // }, [compSearch])

  const updateCorporateData = async () => {
    let corporateId = form.getFieldValue([[formName], 'corporateId'])
    let companyName = form.getFieldValue([[formName], 'organization'])
    const results = await companySearching(companyName)

    if (!corporateId && companyName && isCvTrue) {
      if (results?.length > 0) {
        const corporateObj = results[0]
        if (corporateObj?.companyName?.toLowerCase()?.trim() == companyName?.toLowerCase()?.trim() || results?.length === 1) {
          if (corporateObj) {
            form.setFieldValue([[formName], 'corporateId'], corporateObj?.id)
            form.setFieldValue([[formName], 'organization'], corporateObj?.companyName)
          }
        } else {
          setErrorNote(prevError => ({
            ...prevError,
            [errorCompany]: results?.length
              ? `Searched results for : ${companyName}`
              : `No data matched for : ${companyName}`,
          }))
          if (!results?.length) companySearching('')
          form.setFieldValue([[formName], 'organization'], '')
        }
      } else {
        setErrorNote(prevError => ({
          ...prevError,
          [errorCompany]: results?.length
            ? `Searched results for : ${companyName}`
            : `No data matched for : ${companyName}`,
        }))
        if (!results?.length) companySearching('')
        form.setFieldValue([[formName], 'organization'], '')
      }
    } else {
      companySearching('')
    }
  }
  const updateDesignationData = async () => {
    let roleName = form.getFieldValue([[formName], 'role'])
    const results = await designationSearching(roleName)
    if (roleName && roleName !== '' && isCvTrue) {
      try {
        if (results?.length) {
          let roleObj = results[0]
          if (
            (results && results?.length == 1) ||
            roleObj?.name?.toLowerCase() == roleName?.toLowerCase()
          ) {
            form.setFieldValue([[formName], 'role'], roleObj?.name)
          } else {
            setErrorNote(prevError => ({
              ...prevError,
              [errorRole]: results?.length
                ? `Searched result for : ${roleName}`
                : `No data matched for : ${roleName}`,
            }))
            form.setFieldValue([[formName], 'role'], '')
            if (!results?.length) designationSearching('')
          }
        } else {
          setErrorNote(prevError => ({
            ...prevError,
            [errorRole]: results?.length
              ? `Searched result for : ${roleName}`
              : `No data matched for : ${roleName}`,
          }))
          form.setFieldValue([[formName], 'role'], '')
          if (!results?.length) designationSearching('')
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
  const updateFunctionData = async () => {
    let functionName = form.getFieldValue([[formName], 'function'])
    const results = await functionSearching(functionName)
    if (functionName && functionName !== '' && isCvTrue) {
      try {
        if (results?.length) {
          let functionObj = results[0]
          if (
            (results && results?.length == 1) ||
            functionObj?.name?.toLowerCase() == functionName?.toLowerCase()
          ) {
            form.setFieldValue([[formName], 'function'], functionObj?.name)
          } else {
            setErrorNote(prevError => ({
              ...prevError,
              [errorFunction]: results?.length
                ? `Searched result for : ${functionName}`
                : `No data matched for : ${functionName}`,
            }))
            form.setFieldValue([[formName], 'function'], '')
            if (!results?.length) functionSearching('')
          }
        } else {
          setErrorNote(prevError => ({
            ...prevError,
            [errorFunction]: results?.length
              ? `Searched result for : ${functionName}`
              : `No data matched for : ${functionName}`,
          }))
          form.setFieldValue([[formName], 'function'], '')
          if (!results?.length) functionSearching('')
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
  const updateIndustryData = async () => {
    let industryName = form.getFieldValue([[formName], 'industry'])
    const results = await industrySearching(industryName)
    if (industryName && industryName !== '' && isCvTrue) {
      try {
        if (results?.length) {
          let industryObj = results[0]
          if (
            (results && results?.length == 1) ||
            industryObj?.name?.toLowerCase() == industryName.toLowerCase()
          ) {
            form.setFieldValue([[formName], 'industry'], industryObj?.name)
          } else {
            setErrorNote(prevError => ({
              ...prevError,
              [errorIndustry]: results?.length
                ? `Searched result for : ${industryName}`
                : `No data matched for : ${industryName}`,
            }))
            form.setFieldValue([[formName], 'industry'], '')
            if (!results?.length) industrySearching('')
          }
        } else {
          setErrorNote(prevError => ({
            ...prevError,
            [errorIndustry]: results?.length
              ? `Searched result for : ${industryName}`
              : `No data matched for : ${industryName}`,
          }))
          form.setFieldValue([[formName], 'industry'], '')
          if (!results?.length) industrySearching('')
        }
      } catch (err) {
        console.log(err)
      }
    }
  }

  useEffect(() => {
    setProjectTitle(form.getFieldValue([[formName], 'title']))
  }, [form.getFieldValue([[formName], 'title'])])

  const onRemoveClick = () => {
    setErrorNote({})
    setDeleted(true)
    onRemove(false, true, formName)
  }
  return (
    <>
      {!deleted && (
        <Container column flexStart>
          <Control spaceBetween alignCenter>
            <Control column flexStart>
              <Heading>
                {projectTitle ? projectTitle : getTitle(formName)}
              </Heading>
              <SubHeading>{timeLine ? timeLine : 'Timeline'}</SubHeading>
            </Control>
            <Control gap="10px" flexEnd>
              {!(formName?.includes('experience') ? (frozenFields.workExperience?.addNew) : (formName?.includes('internship') ? (frozenFields.internships?.addNew) : (frozenFields.projects?.addNew))) && (
                <IconView onClick={() => onRemoveClick()}>
                  <Delete />
                </IconView>
              )}
              <IconView onClick={() => showHandler()}>
                <Dropdown />
              </IconView>
            </Control>
          </Control>
          <StyledFormItem show={form.getFieldValue([[formName], 'shown'])}>
            <>
              <Divider />
              {formName?.includes('course') && (
                <Control top="20px" flexStart column>
                  <Label>Institute Name *</Label>
                  <AntdInput
                    placeholder="Eg. Indian Institute of technology"
                    name={[[formName], 'organization']}
                    maxLength={120}
                    rules={[
                      {
                        required: true,
                        min: 3,
                        max: 120,
                        message: `${`Please enter institute name! Minimum 3 characters, Maximum 120 characters.`}`,
                      },
                    ]}
                  />
                </Control>
              )}

              {/* {formName?.includes('experience') && (
                <Control top="20px" flexStart column>
                  <Label>Job Title *</Label>
                  <AntdInput
                    placeholder="Please Enter Job Title"
                    name={[[formName], 'title']}
                    maxLength={120}
                    disabled={formName?.includes('experience') ? (frozenFields.workExperience?.title || frozenFields.workExperience?.addNew) : (frozenFields.projects?.title || frozenFields.projects?.addNew)}
                    rules={[
                      {
                        required: true,
                        min: 3,
                        max: 120,
                        message: `${`Please enter job title! Minimum 3 characters, Maximum 120 characters.`}`,
                      },
                    ]}
                    onBlur={onBlurProjectTitle}
                  />
                </Control>
              )} */}
              {!formName?.includes('course') && (
                <Fragment>
                  <Control top="20px" flexStart column>
                    <Label>
                      {!formName?.includes('project')
                        ? 'Company Name *'
                        : 'Company Name'}
                    </Label>
                    <FormItem name={[[formName], 'organization']} />
                    <FormItem name={[[formName], 'corporateId']} />
                    <AntdSelectNew
                      placeholder="Select Corporate"
                      name={[[formName], 'organization']}
                      nameParam="companyName"
                      valueParam="id"
                      disabled={formName?.includes('experience') ? (frozenFields.workExperience?.companyName || frozenFields.workExperience?.addNew) : (formName?.includes('internship') ? (frozenFields.internships?.companyName || frozenFields.internships?.addNew) : (frozenFields.projects?.title || frozenFields.projects?.addNew))}
                      showSearch={true}
                      allowClear={true}
                      OptionData={companyList}
                      rules={[
                        {
                          required: !formName?.includes('project'),
                          message: 'Please select the Corporate.',
                        },
                      ]}
                      filterOption={false}
                      onSearch={data => delayCompanyToFetch(data?.trim() ?? '')}
                      onChange={onCorporateChange}
                      onBlur={onCorporateBlur}
                      value={form.getFieldValue([[formName], 'organization'])}
                      onClear={() => setCompSearch('')}
                    />

                    {errorNote?.[errorCompany] && (
                      <RedNote>{errorNote?.[errorCompany]}</RedNote>
                    )}
                  </Control>

                  {formName?.includes('experience') && (
                    <>
                      <br></br>
                      <Label>Job Type *</Label>
                      <FormItem
                        name={[[formName], 'jobType']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select the job type',
                          },
                        ]}
                      >
                        <RadioGroupNew
                          onChange={({ target }) =>
                            jobTypeOnchange(target.value)
                          }
                          defaultValue={isJobType}
                        >
                          {RadioOptions?.map((item, index) => (
                            <Radio
                              width={'50%'}
                              key={index}
                              border={true}
                              label={item?.label}
                              value={item?.value}
                            />
                          ))}
                        </RadioGroupNew>
                      </FormItem>
                    </>
                  )}
                  {!(
                    formName?.includes('experience') ||
                    formName?.includes('internship')
                  ) && (
                    <Control top="20px" flexStart column>
                      <Label>Project Title * </Label>
                      <AntdInput
                        placeholder="Please Enter Project Title"
                        name={[[formName], 'title']}
                        maxLength={120}
                        disabled={formName?.includes('internship') ? (frozenFields.internships?.title || frozenFields.internships?.addNew) : (frozenFields.projects?.title || frozenFields.projects?.addNew)}
                        rules={[
                          {
                            min: 3,
                            max: 120,
                            message: `${`Please enter project title! Minimum 3 characters, Maximum 120 characters.`}`,
                          },
                          {
                            required: true,
                            message: 'Please enter the Project title.',
                          },
                        ]}
                        onBlur={onBlurProjectTitle}
                      />
                    </Control>
                  )}
                </Fragment>
              )}
              {formName?.includes('experience') && (
                <Fragment>
                  <Control spaceBetween top="20px" gap="20px">
                    <Control flexStart column>
                      <FormItem name={[[formName], 'startMonth']}>
                        <div></div>
                      </FormItem>
                      <Label>Start Month*</Label>
                      <AntdSelect
                        placeholder="Eg.March"
                        name={[[formName], 'startMonth']}
                        rules={[
                          {
                            required: true,
                            message: '',
                          },
                          {
                            validator: workValidator,
                          },
                        ]}
                        OptionData={MonthList}
                        valueParam="value"
                        nameParam="name"
                        onChange={value => {
                          onStartMonthChange(value)
                          form.validateFields(
                            [[formName], 'startMonth'],
                            (errors, values) => {
                              if (!errors) {
                                setWorkErrorMsg('')
                              } else {
                                setWorkErrorMsg(
                                  errors[[formName]].startMonth.errors[0]
                                    .message
                                )
                              }
                            }
                          )
                          workValidator(null, null)
                        }}
                        value={form.getFieldValue([[formName], 'startMonth'])}
                        allowClear={true}
                        showSearch={true}
                        filterOption={(input, option) =>
                          option?.name
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        disable={formName?.includes('experience') ? (frozenFields.workExperience?.startMonth || frozenFields.workExperience?.startYear) : (formName?.includes('internship') ? (frozenFields.internships?.startMonth || frozenFields.internships?.startYear) : (frozenFields.projects?.startMonth || frozenFields.projects?.startYear))}
                      />
                    </Control>
                    <Control flexStart column>
                      <FormItem name={[[formName], 'startYear']}>
                        <div></div>
                      </FormItem>
                      <Label> Start Year *</Label>
                      <AntdSelect
                        placeholder="Eg.2020"
                        name={[[formName], 'startYear']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select Started Year!',
                          },
                          {
                            validator: workValidator,
                          },
                        ]}
                        OptionData={years}
                        valueParam="value"
                        nameParam="name"
                        onChange={value => {
                          onStartYearChange(value)
                          form.validateFields(
                            [[formName], 'startYear'],
                            (errors, values) => {
                              if (!errors) {
                                setWorkErrorMsg('')
                              } else {
                                setWorkErrorMsg(
                                  errors[[formName]].startYear.errors[0].message
                                )
                              }
                            }
                          )
                          workValidator(null, null)
                        }}
                        value={form.getFieldValue([[formName], 'startYear'])}
                        allowClear={true}
                        showSearch={true}
                        disable={formName?.includes('experience') ? (frozenFields.workExperience?.startMonth || frozenFields.workExperience?.startYear) : (formName?.includes('internship') ? (frozenFields.internships?.startMonth || frozenFields.internships?.startYear) : (frozenFields.projects?.startMonth || frozenFields.projects?.startYear))}
                      />
                    </Control>
                  </Control>

                  <FormItem name={[[formName], 'started_in']} />

                  {(!isPresent || isCurrentlyWorking) && (
                    <Control spaceBetween top="20px" gap="20px">
                      <Control flexStart column></Control>
                      <Control flexStart column>
                        <Checkbox
                          onChange={isCurrentlyOnChange}
                          checked={isCurrentlyWorking}
                        >
                          {'I am currently working'}
                        </Checkbox>
                      </Control>
                    </Control>
                  )}

                  <FormItem name={[[formName], 'isCurrentlyWorking']} />
                  {!isCurrentlyWorking && (
                    <>
                      <Control spaceBetween top="20px" gap="20px">
                        <Control flexStart column>
                          <FormItem name={[[formName], 'endMonth']}>
                            <div></div>
                          </FormItem>
                          <Label>End Month*</Label>
                          <AntdSelect
                            placeholder="Eg.March"
                            name={[[formName], 'endMonth']}
                            rules={[
                              {
                                required: true,
                                message: '',
                              },
                              {
                                validator: workValidator,
                              },
                            ]}
                            OptionData={MonthList}
                            valueParam="value"
                            nameParam="name"
                            onChange={value => {
                              onEndMonthChange(value)
                              form.validateFields(
                                [[formName], 'endMonth'],
                                (errors, values) => {
                                  if (!errors) {
                                    setWorkErrorMsg('')
                                  } else {
                                    setWorkErrorMsg(
                                      errors[[formName]].endMonth.errors[0]
                                        .message
                                    )
                                  }
                                }
                              )
                              workValidator(null, null)
                            }}
                            value={form.getFieldValue([[formName], 'endMonth'])}
                            allowClear={true}
                            showSearch={true}
                            filterOption={(input, option) =>
                              option?.name
                                ?.toLowerCase()
                                ?.indexOf(input?.toLowerCase()) >= 0
                            }
                            disabled={
                              form.getFieldValue([[formName], 'started_in'])
                                ? false
                                : true
                            }
                          />
                        </Control>
                        <Control flexStart column>
                          <FormItem name={[[formName], 'endYear']}>
                            <div></div>
                          </FormItem>
                          <Label> End Year *</Label>
                          <AntdSelect
                            placeholder="Eg.2020"
                            name={[[formName], 'endYear']}
                            rules={[
                              {
                                required: true,
                                message: 'Please select Ended Year!',
                              },
                              {
                                validator: workValidator,
                              },
                              //{ validator: validateStartEndDate }
                            ]}
                            OptionData={years}
                            valueParam="value"
                            nameParam="name"
                            onChange={value => {
                              onEndYearChange(value)
                              form.validateFields(
                                [[formName], 'endYear'],
                                (errors, values) => {
                                  if (!errors) {
                                    setWorkErrorMsg('')
                                  } else {
                                    setWorkErrorMsg(
                                      errors[[formName]].endYear.errors[0].message
                                    )
                                  }
                                }
                              )
                              workValidator(null, null)
                            }}
                            value={form.getFieldValue([[formName], 'endYear'])}
                            allowClear={true}
                            showSearch={true}
                            disabled={
                              form.getFieldValue([[formName], 'started_in'])
                                ? false
                                : true
                            }
                          />
                        </Control>
                      </Control>

                      <FormItem
                        // rule={[
                        //    { validator: validateStartEndDate }
                        // ]
                        // }
                        name={[[formName], 'ended_in']}
                      />
                    </>
                  )}

                  {workErrorMsg && (
                    <p style={{ color: 'red' }}>{workErrorMsg}</p>
                  )}

                  {isCurrentlyWorking && (
                    <Control flexStart column>
                      <FormItem name={[[formName], 'noticePeriod']}>
                        <div></div>
                      </FormItem>
                      <Label> Notice Period (In Days) *</Label>
                      <AntdSelect
                        placeholder="Eg.0-15"
                        name={[[formName], 'noticePeriod']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select Notice Period!',
                          },
                        ]}
                        OptionData={NoticePeriodList}
                        valueParam="value"
                        nameParam="name"
                        onChange={value => onNoticePeriodChange(value)}
                        value={noticePeriod}
                      />
                    </Control>
                  )}
                </Fragment>
              )}

              {!formName?.includes('experience') && (
                <Fragment>
                  <Control spaceBetween top="20px" gap="20px">
                    <Control flexStart column>
                      <Label>Start Month* </Label>
                      <FormItem name={[[formName], 'startMonth']}>
                        <div></div>
                      </FormItem>
                      <AntdSelect
                        placeholder="Eg.March"
                        name={[[formName], 'startMonth']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select Started Month!',
                          },
                          {
                            validator: validator,
                          },
                        ]}
                        OptionData={MonthList}
                        valueParam="value"
                        nameParam="name"
                        onChange={value => {
                          onStartMonthChange(value)
                          form.validateFields(
                            [[formName], 'startMonth'],
                            (errors, values) => {
                              if (!errors) {
                                setDateErrorMsg('')
                              } else {
                                setDateErrorMsg(
                                  errors[[formName]].startMonth.errors[0]
                                    .message
                                )
                              }
                            }
                          )
                          validator(null, null)
                        }}
                        value={form.getFieldValue([[formName], 'startMonth'])}
                        allowClear={true}
                        showSearch={true}
                        filterOption={(input, option) =>
                          option?.name
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        disable={formName?.includes('experience') ? (frozenFields.workExperience?.startMonth || frozenFields.workExperience?.startYear) : (formName?.includes('internship') ? (frozenFields.internships?.startMonth || frozenFields.internships?.startYear) : (frozenFields.projects?.startMonth || frozenFields.projects?.startYear))}
                      />
                    </Control>

                    <Control flexStart column>
                      <FormItem name={[[formName], 'startYear']}>
                        <div></div>
                      </FormItem>
                      <Label> Start Year *</Label>
                      <AntdSelect
                        placeholder="Eg.2020"
                        name={[[formName], 'startYear']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select Started Year!',
                          },
                          {
                            validator: validator,
                          },
                        ]}
                        OptionData={years}
                        valueParam="value"
                        nameParam="name"
                        onChange={value => {
                          onStartYearChange(value)
                          form.validateFields(
                            [[formName], 'startYear'],
                            (errors, values) => {
                              if (!errors) {
                                setDateErrorMsg('')
                              } else {
                                setDateErrorMsg(
                                  errors[[formName]].startYear.errors[0].message
                                )
                              }
                            }
                          )
                          validator(null, null)
                        }}
                        value={form.getFieldValue([[formName], 'startYear'])}
                        allowClear={true}
                        showSearch={true}
                        disable={formName?.includes('experience') ? (frozenFields.workExperience?.startMonth || frozenFields.workExperience?.startYear) : (formName?.includes('internship') ? (frozenFields.internships?.startMonth || frozenFields.internships?.startYear) : (frozenFields.projects?.startMonth || frozenFields.projects?.startYear))}
                      />
                    </Control>
                  </Control>

                  <FormItem name={[[formName], 'started_in']}>
                    <div> </div>
                  </FormItem>

                  <Control spaceBetween top="20px" gap="20px">
                    <Control flexStart column>
                      <FormItem name={[[formName], 'endMonth']}>
                        <div></div>
                      </FormItem>

                      <Label>End Month*</Label>
                      <AntdSelect
                        placeholder="Eg.March"
                        name={[[formName], 'endMonth']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select Ended Month!',
                          },
                          {
                            validator: validator,
                          },
                        ]}
                        OptionData={MonthList}
                        valueParam="value"
                        nameParam="name"
                        onChange={value => {
                          onEndMonthChange(value)
                          form.validateFields(
                            [[formName], 'endMonth'],
                            (errors, values) => {
                              if (!errors) {
                                setDateErrorMsg('')
                              } else {
                                setDateErrorMsg(
                                  errors[[formName]].endMonth.errors[0].message
                                )
                              }
                            }
                          )
                          validator(null, null)
                        }}
                        value={form.getFieldValue([[formName], 'endMonth'])}
                        allowClear={true}
                        showSearch={true}
                        filterOption={(input, option) =>
                          option?.name
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        disabled={
                          (form.getFieldValue([[formName], 'started_in']) 
                            ? false 
                            : true) || 
                          (formName?.includes('experience') 
                            ? (frozenFields.workExperience?.endMonth || frozenFields.workExperience?.endYear) 
                            : (formName?.includes('internship') 
                              ? (frozenFields.internships?.endMonth || frozenFields.internships?.endYear) 
                              : (frozenFields.projects?.endMonth || frozenFields.projects?.endYear)))
                        }
                      />
                    </Control>
                    <Control flexStart column>
                      <FormItem name={[[formName], 'endYear']}>
                        <div></div>
                      </FormItem>
                      <Label> End Year *</Label>
                      <AntdSelect
                        placeholder="Eg.2020"
                        name={[[formName], 'endYear']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select Ended Year!',
                          },
                          {
                            validator: validator,
                          },
                          //{ validator: validateStartEndDate }
                        ]}
                        OptionData={years}
                        valueParam="value"
                        nameParam="name"
                        onChange={value => {
                          onEndYearChange(value)
                          form.validateFields(
                            [[formName], 'endYear'],
                            (errors, values) => {
                              if (!errors) {
                                setDateErrorMsg('')
                              } else {
                                setDateErrorMsg(
                                  errors[[formName]].endYear.errors[0].message
                                )
                              }
                            }
                          )
                          validator(null, null)
                        }}
                        value={form.getFieldValue([[formName], 'endYear'])}
                        allowClear={true}
                        showSearch={true}
                        disabled={
                          (form.getFieldValue([[formName], 'started_in'])
                            ? false
                            : true
                          ) || (formName?.includes('experience') ? (frozenFields.workExperience?.endMonth || frozenFields.workExperience?.endYear) : (formName?.includes('internship') ? (frozenFields.internships?.endMonth || frozenFields.internships?.endYear) : (frozenFields.projects?.endMonth || frozenFields.projects?.endYear)))
                        }
                      />
                    </Control>
                  </Control>

                  {dateErrorMsg && (
                    <p style={{ color: 'red' }}>{dateErrorMsg}</p>
                  )}

                  <FormItem
                    // rule={[
                    //    { validator: validateStartEndDate }
                    // ]
                    // }
                    name={[[formName], 'ended_in']}
                  />
                </Fragment>
              )}
              {formName?.includes('course') && (
                <Control top="20px" flexStart column>
                  <Label>Course Name *</Label>
                  <AntdInput
                    placeholder="Please Enter Course Name"
                    name={[[formName], 'title']}
                    maxLength={120}
                    disabled={frozenFields.certifications?.title || frozenFields.certifications?.addNew}
                    rules={[
                      {
                        required: true,
                        min: 3,
                        max: 120,
                        message: `${`Please enter course name! Minimum 3 characters, Maximum 120 characters.`}`,
                      },
                    ]}
                  />
                </Control>
              )}
              {(formName?.includes('project') ||
                formName?.includes('internship')) && (
                <Fragment>
                  <Control top="20px" flexStart column>
                    <Label>Function</Label>
                    <FormItem name={[[formName], 'function']} />
                    <FormItem name={[[formName], 'addFunction']} />
                    <AntdSelect
                      placeholder="Eg.Operation"
                      name={[[formName], 'function']}
                      OptionData={functionsList || []}
                      valueParam="name"
                      nameParam="name"
                      showSearch={true}
                      onSearch={data => delayFunctionToFetch(data?.trim())}
                      onChange={onFunctionChange}
                      value={
                        form.getFieldValue([[formName], 'addFunction']) ===
                        'OTHER'
                          ? 'Other'
                          : form.getFieldValue([[formName], 'function'])
                      }
                      filterOption={false}
                      disabled={formName?.includes('experience') ? (frozenFields.workExperience?.function || frozenFields.workExperience?.addNew) : (formName?.includes('internship') ? (frozenFields.internships?.function || frozenFields.internships?.addNew) : (frozenFields.projects?.function || frozenFields.projects?.addNew))}
                    />
                    {errorNote?.[errorFunction] && (
                      <RedNote>{errorNote?.[errorFunction]}</RedNote>
                    )}
                  </Control>
                  {form.getFieldValue([[formName], 'addFunction']) ===
                    'OTHER' && (
                    <Control top="20px" flexStart column>
                      <Label>Please enter the Function name</Label>
                      <AntdInput
                        placeholder="Enter the Function name"
                        name={[[formName], 'function']}
                        value={form.getFieldValue([[formName], 'function'])}
                        rules={[
                          {
                            required: true,
                            message: 'Please enter the Function name.',
                          },
                        ]}
                        onChange={e => {
                          // setIsCurrentlyWorking(false)
                        }}
                        onBlur={() => onBlurHandler('function')}
                      />
                    </Control>
                  )}
                  <Control top="20px" flexStart column>
                    <Label>Role</Label>
                    <AntdSelectNew
                      placeholder="Eg.Mechanical"
                      name={[[formName], 'role']}
                      OptionData={options || []}
                      valueParam="name"
                      nameParam="name"
                      showSearch={true}
                      onSearch={data => setRoleSearch(data?.trim())}
                      onChange={value => {
                        onRoleChange(value)
                      }}
                      value={form?.getFieldValue([[formName], 'role'])}
                      onClear={() => setRoleSearch('')}
                      filterOption={false}
                      disabled={formName?.includes('experience') ? (frozenFields.workExperience?.role || frozenFields.workExperience?.addNew) : (formName?.includes('internship') ? (frozenFields.internships?.role || frozenFields.internships?.addNew) : (frozenFields.projects?.role || frozenFields.projects?.addNew))}
                    />
                    {errorNote?.[errorRole] && (
                      <RedNote>{errorNote?.[errorRole]}</RedNote>
                    )}
                  </Control>
                  <Control top="20px" flexStart column>
                    <Label>Industry</Label>
                    <FormItem name={[[formName], 'industry']} />
                    <FormItem name={[[formName], 'addIndustry']} />
                    <AntdSelect
                      placeholder="Eg.Mechanical"
                      name={[[formName], 'industry']}
                      OptionData={industryList || []}
                      valueParam="name"
                      nameParam="name"
                      showSearch={true}
                      onSearch={data => delayIndustryToFetch(data?.trim())}
                      onChange={onIndustryChange}
                      value={
                        form.getFieldValue([[formName], 'addIndustry']) ===
                        'OTHER'
                          ? 'Other'
                          : form.getFieldValue([[formName], 'industry'])
                      }
                      filterOption={false}
                      disabled={formName?.includes('experience') ? (frozenFields.workExperience?.industry || frozenFields.workExperience?.addNew) : (formName?.includes('internship') ? (frozenFields.internships?.industry || frozenFields.internships?.addNew) : (frozenFields.projects?.industry || frozenFields.projects?.addNew))}
                    />
                    {errorNote?.[errorIndustry] && (
                      <RedNote>{errorNote?.[errorIndustry]}</RedNote>
                    )}
                  </Control>
                  {form.getFieldValue([[formName], 'addIndustry']) ===
                    'OTHER' && (
                    <Control top="20px" flexStart column>
                      <Label>Please enter the Industry name</Label>
                      <AntdInput
                        placeholder="Enter the Industry name"
                        name={[[formName], 'industry']}
                        value={form.getFieldValue([[formName], 'industry'])}
                        rules={[
                          {
                            required: true,
                            message: 'Please enter the Industry name.',
                          },
                        ]}
                        onChange={e => {
                          // setIsCurrentlyWorking(false)
                        }}
                        onBlur={() => onBlurHandler('industry')}
                      />
                    </Control>
                  )}
                </Fragment>
              )}
              {formName?.includes('experience') && (
                <Fragment>
                  <Control top="20px" flexStart column width="49%">
                    <FormItem name={[[formName], 'function']}>
                      <div></div>
                    </FormItem>
                    <Label>Function *</Label>
                    <FormItem name={[[formName], 'function']} />
                    <FormItem name={[[formName], 'addFunction']} />
                    <AntdSelect
                      rules={[
                        {
                          required: true,
                          message: 'Please select Function!',
                        },
                      ]}
                      placeholder="Eg.Operation"
                      name={[[formName], 'function']}
                      OptionData={functionsList || []}
                      valueParam="name"
                      nameParam="name"
                      showSearch={true}
                      onSearch={data => delayFunctionToFetch(data)}
                      onChange={onFunctionChange}
                      value={
                        form.getFieldValue([[formName], 'addFunction']) ===
                        'OTHER'
                          ? 'Other'
                          : form.getFieldValue([[formName], 'function'])
                      }
                      filterOption={false}
                    />
                    {errorNote?.[errorFunction] && (
                      <RedNote>{errorNote?.[errorFunction]}</RedNote>
                    )}
                  </Control>
                  {form.getFieldValue([[formName], 'addFunction']) ===
                    'OTHER' && (
                    <Control top="20px" flexStart column>
                      <Label>Please enter the Function name</Label>
                      <AntdInput
                        placeholder="Enter the Function name"
                        name={[[formName], 'function']}
                        value={form.getFieldValue([[formName], 'function'])}
                        rules={[
                          {
                            required: true,
                            message: 'Please enter the Function name.',
                          },
                        ]}
                        onChange={e => {
                          // setIsCurrentlyWorking(false)
                        }}
                        onBlur={() => onBlurHandler('function')}
                      />
                    </Control>
                  )}

                  <Control top="20px" flexStart column>
                    <FormItem name={[[formName], 'role']}>
                      <div></div>
                    </FormItem>
                    <Label>Role *</Label>
                    <AntdSelectNew
                      rules={[
                        {
                          required: true,
                          message: 'Please select Role!',
                        },
                      ]}
                      placeholder="Eg.Mechanical"
                      name={[[formName], 'role']}
                      OptionData={options}
                      valueParam="name"
                      nameParam="name"
                      showSearch={true}
                      onChange={value => {
                        onRoleChange(value)
                      }}
                      value={form?.getFieldValue([[formName], 'role'])}
                      onSearch={data => setRoleSearch(data?.trim() ?? '')}
                      filterOption={false}
                      onBlur={() => onBlurHandler('role')}
                    />
                    {errorNote?.[errorRole] && (
                      <RedNote>{errorNote?.[errorRole]}</RedNote>
                    )}
                  </Control>
                  <Control top="20px" flexStart column>
                    <FormItem name={[[formName], 'industry']}>
                      <div></div>
                    </FormItem>
                    <Label>Industry *</Label>
                    <FormItem name={[[formName], 'industry']} />
                    <FormItem name={[[formName], 'addIndustry']} />

                    <AntdSelect
                      rules={[
                        {
                          required: true,
                          message: 'Please select industry!',
                        },
                      ]}
                      placeholder="Eg.Mechanical"
                      name={[[formName], 'industry']}
                      OptionData={industryList || []}
                      valueParam="name"
                      nameParam="name"
                      showSearch={true}
                      onSearch={data => delayIndustryToFetch(data)}
                      onChange={onIndustryChange}
                      value={
                        form.getFieldValue([[formName], 'addIndustry']) ===
                        'OTHER'
                          ? 'Other'
                          : form.getFieldValue([[formName], 'industry'])
                      }
                      filterOption={false}
                    />
                    {errorNote?.[errorIndustry] && (
                      <RedNote>{errorNote?.[errorIndustry]}</RedNote>
                    )}
                  </Control>
                  {form.getFieldValue([[formName], 'addIndustry']) ===
                    'OTHER' && (
                    <Control top="20px" flexStart column>
                      <Label>Please enter the Industry name</Label>
                      <AntdInput
                        placeholder="Enter the Industry name"
                        name={[[formName], 'industry']}
                        value={form.getFieldValue([[formName], 'industry'])}
                        rules={[
                          {
                            required: true,
                            message: 'Please enter the Industry name.',
                          },
                        ]}
                        onChange={e => {
                          // setIsCurrentlyWorking(false)
                        }}
                        onBlur={() => onBlurHandler('industry')}
                      />
                    </Control>
                  )}
                </Fragment>
              )}

              <Control top="20px" flexStart column>
                <Label>Description</Label>
                <FormItem
                  name={[[formName], 'description']}
                  rules={[
                    {
                      validator: async (_, value) => {
                        if (countRichTextCharacters(value) > 1000) {
                          return Promise.reject(
                            'Maximum 1000 Character allowed!'
                          )
                        }

                        return Promise.resolve()
                      },
                    },
                  ]}
                >
                  <RichEditor
                    value={description}
                    onChange={onChangeDescription}
                  />
                </FormItem>
                {'Characters: ' +
                  countRichTextCharacters(
                    form.getFieldValue([[formName], 'description'])
                  ) +
                  ' / 1000'}
              </Control>
              <Control top="20px" flexStart column>
                <FormItem name={[[formName], 'skill_set']}>
                  <div></div>
                </FormItem>
                <Label>Skills utilised/gained *</Label>
                <AntdSelect
                  placeholder="Eg.React.js"
                  name={[[formName], 'skill_set']}
                  rules={[
                    {
                      validator: async (_, value) => {
                        if (!selectedSkill?.length) {
                          if (!Array.isArray(value)) {
                            return Promise.reject('Please select skills!')
                          } else if (value?.length === 0) {
                            return Promise.reject('Please select skills!')
                          }
                        }
                        return Promise.resolve()
                      },
                    },
                    {
                      validator: validateSkill,
                    },
                  ]}
                  OptionData={listOfSkills}
                  valueParam="id"
                  nameParam="name"
                  onChange={(value, id) => onSkillChange(value, id)}
                  value={selectedSkill}
                  mode="multiple"
                  disabled={skillFetch}
                  showSearch={true}
                  onSearch={data => {
                    delaySkillToFetch(data)}
                  }
                  filterOption={false}
                  onDropdownVisibleChange={open => {
                    if (!open) {
                      delaySkillToFetch('')
                      form.setFieldsValue({
                        [formName]: { skill_set: storeSkill },
                      })
                    }
                  }}
                />
                {skillErrorMsg && (
                  <p style={{ color: 'red' }}>{skillErrorMsg}</p>
                )}
                {'Skills: ' + selectedSkill?.length + ' / 20'}
              </Control>
              {!formName?.includes('experience') && (
                <Control flexStart column top="20px">
                  <FormItem name={[[formName], 'certificate']}>
                    <Label>Certificate </Label>
                    {file && Object.keys(file)?.length > 0 && file?.size ? (
                      <Control column top="10px" center>
                        <FileReaderVisible 
                          file={file} 
                          setFile={setFile}
                          disabled={formName?.includes('experience') ? (frozenFields.workExperience?.certificate || frozenFields.workExperience?.addNew) : (formName?.includes('internship') ? (frozenFields.internships?.certificate || frozenFields.internships?.addNew) : (frozenFields.projects?.certificate || frozenFields.projects?.addNew))}
                        />
                      </Control>
                    ) : (
                      <Control column top="10px" center>
                        <Uploadloader
                          setFile={setFile}
                          isDefault={true}
                          fileName={
                            studentFormData?.admin?.firstName?.toLowerCase() +
                            '_' +
                            getFormName(formName) +
                            '_certificate'
                          }
                        />
                      </Control>
                    )}
                  </FormItem>
                </Control>
              )}
            </>
          </StyledFormItem>
          <br></br>
          {(studentFormData?.student?.isExpCandidate ||
            formName?.includes('experience')) && (
            <>
              <Control top="20px" alignCenter gap="10px">
                <Heading>Rewards & Recogination</Heading>
                <SubHeading>(optional)</SubHeading>
              </Control>
              {!!award?.length &&
                award?.map((obj, idx) => {
                  return (
                    <obj.component
                      key={idx}
                      form={form}
                      onRemove={awardHandle}
                      formName={obj?.formName}
                      studentFormData={studentFormData}
                      setDeleted={setDeleted}
                    />
                  )
                })}
              <LocalDiv onClick={() => awardHandle(true, false)}>
                <Control alignCenter gap="10px">
                  <AdjustIcon>
                    <AddIcon />
                  </AdjustIcon>
                  <Text>Add Awards</Text>
                </Control>
              </LocalDiv>
            </>
          )}
        </Container>
      )}
    </>
  )
}

export default ProjectForm
